import { ColorizableArea } from '@/models/entities/Location';

export class ImageFile {
  public fileId: number = 0;
  public fileName: string = '';
  public url: string = '';
  public colorizableAreas?: ColorizableArea[] = [];

  constructor(initData: Partial<ImageFile>) {
    Object.assign(this, initData);
  }
}
